<template>
  <el-form-item :label="label" :prop="prop" :rules="rules">
    <el-select
      v-model="selectedValue"
      :placeholder="placeholder"
      @change="handleSelect"
      :multiple="multiple"
      filterable
      allow-create
      default-first-option
      :reserve-keyword="false"
    >
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      />
      <template #footer>
        <el-button v-if="!isAdding" text bg size="small" @click="startAdding">
          添加选项
        </el-button>
        <template v-else>
          <el-input
            v-model="newOption"
            class="option-input"
            :placeholder="placeholder"
            size="small"
          />
          <el-button type="primary" size="small" @click="handleConfirm">
            确认
          </el-button>
          <el-button size="small" @click="cancelAdding"> 取消 </el-button>
        </template>
      </template>
    </el-select>
  </el-form-item>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "SelectWithAdd",

  props: {
    modelValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    prop: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [Array, Object],
      default: () => [
        { required: true, message: "此项为必填项", trigger: "change" },
      ],
    },
  },

  emits: ["update:modelValue", "add-option"],

  setup(props, { emit }) {
    const isAdding = ref(false);
    const newOption = ref("");
    const selectedValue = ref(props.modelValue);

    // 监听 modelValue 的变化
    watch(
      () => props.modelValue,
      (newVal) => {
        selectedValue.value = newVal;
      }
    );

    // 监听 selectedValue 的变化
    watch(selectedValue, (newVal) => {
      emit("update:modelValue", newVal);
    });

    const startAdding = () => {
      isAdding.value = true;
    };

    const cancelAdding = () => {
      isAdding.value = false;
      newOption.value = "";
    };

    const handleConfirm = () => {
      if (newOption.value.trim()) {
        emit("add-option", newOption.value.trim());
        newOption.value = "";
        isAdding.value = false;
      }
    };

    const handleSelect = (value) => {
      emit("update:modelValue", value);
    };

    return {
      isAdding,
      newOption,
      selectedValue,
      startAdding,
      cancelAdding,
      handleConfirm,
      handleSelect,
    };
  },
};
</script>

<style lang="scss" scoped>
.option-input {
  @apply w-full mb-2;
}
</style>
